<template>
  <div>
    <el-row class="w120 mc mt20 home">
      <el-col class="pr20" :span="8">
        <!-- <CardAppOffice /> -->
        <CardOffice :more-url="`/server_my_office?active_name=1`" :get-url="`task/countTaskList`" />
        <CardServeRank class="mt20" />
        <CardServeCenter class="mt20" v-if="userData && userData.routeJur.OfficeBiz" />
        <!-- <CardServe class="mt20" :more-url="`/server_my_office`" :get-url="`task/trackTaskHisList`" /> -->
        <!-- <CardAppTop class="mt20" :title="`最新服务`" :more-url="`/serve`" :get-url="`serve/findNewestServe`" /> -->
      </el-col>
      <el-col :span="16">
        <!-- <CardMyOfficeNew /> -->
        <CardMyOffice :title="`我的事务`" :more-url="`/server_my_office`" />
        <CardAppBot class="mt20" ref="cardBot" :title="`常用服务`" :more-name="`我的收藏`" :more-url="`/server_collect`" :get-url="`serveUse/query`" @show-set-use-view="cardSetUserShowView" />
        <!-- <CardApp class="mt20" :title="`服务大厅`" :more-url="`/serve`" :get-url="`serve/query`" /> -->
        <CardAppTop class="mt20" :title="`最新服务`" :more-url="`/serve`" :get-url="`serve/findNewestServe`" />
      </el-col>
    </el-row>
    <CardSetUser ref="setUse" @hide-view="cardSetUserHideView" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import CardAppOffice from "@/components/Home/CardAppOffice";
import CardOffice from "@/components/Home/CardOffice";
import CardServeRank from "@/components/Home/CardServeRank";
import CardServeCenter from "@/components/Home/CardServeCenter";
// import CardMyOfficeNew from "@/components/Home/CardMyOfficeNew";
import CardMyOffice from "@/components/Home/CardMyOffice";
import CardAppBot from "@/components/Home/CardAppBot";
import CardAppTop from "@/components/Home/CardAppTop";
import CardSetUser from "@/components/Home/CardSetUser";

export default {
  components: {
    CardOffice,
    CardMyOffice,
    CardAppTop,
    CardAppOffice,
    CardServeRank,
    CardServeCenter,
    CardAppBot,
    CardSetUser
  },
  name: "home",
  computed: {
    ...mapState(["userData"])
  },
  mounted() {},
  methods: {
    cardSetUserShowView() {
      this.$refs.setUse.showView();
    },
    cardSetUserHideView() {
      this.$refs.cardBot.fetchData();
    }
  }
};
</script>

<style>
.home {
  padding: 0;
}

.card-title {
  padding: 3px 0 0 0;
  height: 43px;
  line-height: 40px;
}

.card-main {
  min-height: 120px;
}

.card-list {
  padding: 0 20px 0 30px;
  height: 40px;
  line-height: 40px;
}

.card-list:hover {
  background: #eeeeee;
}

.card-list::before {
  content: "";
  display: block;
  position: absolute;
  left: 12px;
  top: 17px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #bfbfbf;
}

.card-list-badge {
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 50%;
  background: #d1a454;
}

.card-shadow::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 3px;
  background: #475eb7;
}
</style>
